export default [
  {
    id: "1654283067378",
    messages: {
      1654283078127: {
        timeSent: 1654283078127,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1654283078127,
        reaction: [],
        body: "Hey, Olive!",
      },
      1672298320475: {
        timeSent: 1672298320475,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1672298320475,
        reaction: [],
        body: "What’s happening?!\n",
      },
      1672298336683: {
        timeSent: 1672298336683,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1672298336683,
        reaction: [],
        body: "Hhjhh\n",
      },
    },
    participantKeys: [
      {
        phoneNumber: "(636) 212-4414",
        role: "client",
        profilePicture:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
        userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Cole",
        family_name: "Coleman",
        email: "admin@simplecitysoftware.com",
      },
      {
        phoneNumber: "1234567890",
        role: "client",
        userId: "0f1534da-3974-4be1-a978-88cbb7330537",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Olive",
        family_name: "Tree",
        username: "testclient@simplecitysoftware.com",
        email: "testclient@simplecitysoftware.co",
      },
    ],
    sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
    contactsRetrieved: true,
  },

  {
    id: "1654283307410",
    messages: {
      1671777489110: {
        timeSent: 1671777489110,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1671777489110,
        reaction: [],
        body: "Hey, David! Let's start a new chat!\n",
      },
    },
    participantKeys: [
      {
        phoneNumber: "(636) 212-4414",
        role: "client",
        profilePicture:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
        userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Cole",
        family_name: "Coleman",
        email: "admin@simplecitysoftware.com",
      },
      {
        phoneNumber: "8529637410",
        role: "employee",
        profilePicture:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116210127",
        userId: "41e7998a-deda-4ec5-8968-09976708aa6a",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "David",
        family_name: "Rose",
        username: "david.rose@simplecitysoftware.com",
        email: "david.rose@simplecitysoftware.com",
      },
    ],
    sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
    contactsRetrieved: true,
  },

  {
    id: "1656116593540",
    messages: {
      1671777637439: {
        timeSent: 1671777637439,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1671777637439,
        reaction: [],
        body: "What's happenin' Pete!?\n",
      },
    },
    participantKeys: [
      {
        phoneNumber: "(636) 212-4414",
        role: "client",
        profilePicture:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
        userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Cole",
        family_name: "Coleman",
        email: "admin@simplecitysoftware.com",
      },
      {
        phoneNumber: "1234567894",
        role: "vendor",
        profilePicture:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa1656116885967",
        userId: "de8abc34-2c29-4aef-ad71-26187c82fe11",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Peter",
        family_name: "Parker",
        username: "peter.parker@simplecitysoftware.com",
        email: "peter.parker@simplecitysoftware.com",
      },
    ],
    sortKey: "f48f259e-37d9-4003-be97-7181858b98aa",
    contactsRetrieved: true,
  },
  {
    id: "1654284404134",
    messages: {
      1654284414855: {
        timeSent: 1654284414855,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
        },
        read: false,
        id: 1654284414855,
        reaction: [],
        body: "Hi, Cole!",
      },
      1654285628370: {
        timeSent: 1654285628370,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1654285628370,
        reaction: [],
        body: "Hey, Bruce!",
      },
      1657863753599: {
        timeSent: 1657863753599,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1657863753599,
        reaction: [],
        body: "This is a longer string of text, so it should be two lines long and take up more space",
      },
      1657863779582: {
        timeSent: 1657863779582,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1657863779582,
        reaction: [],
        body: "k\nk\nk\nk\nk\nk\nk\n",
      },
      1657863813449: {
        timeSent: 1657863813449,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1657863813449,
        reaction: [],
        body: "this is a longer string of text\n",
      },
      1657863954065: {
        timeSent: 1657863954065,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1657863954065,
        reaction: [],
        body: "This is a longer string of text, so it should be two lines long and take up more space",
      },
      1657864188663: {
        timeSent: 1657864188663,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1657864188663,
        reaction: [],
        body: "Hey. Cole!",
      },
      1671772421714: {
        timeSent: 1671772421714,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        },
        read: false,
        id: 1671772421714,
        reaction: [],
        body: "Hey, Bruce! Let's hope this works like it should! What do you say?\n",
      },
      1671809295024: {
        timeSent: 1671809295024,
        senderKey: {
          tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
          userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
        },
        read: false,
        id: 1671809295024,
        reaction: [],
        body: "Hey, Cole! Looks like it came through on my end. Do you think it works on your end? Check before yo push this update.\n",
      },
    },
    participantKeys: [
      {
        phoneNumber: "1234567890",
        role: "client",
        userId: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Bruce",
        family_name: "Banner",
        username: "bruce.banner@simplecitysoftware.com",
        email: "bruce.banner@simplecitysoftware.com",
      },
      {
        phoneNumber: "(636) 212-4414",
        role: "client",
        profilePicture:
          "https://spindjappstorage140016-prod.s3.amazonaws.com/public/f48f259e-37d9-4003-be97-7181858b98aa/f48f259e-37d9-4003-be97-7181858b98aa/1670890084331",
        userId: "f48f259e-37d9-4003-be97-7181858b98aa",
        tenantId: "f48f259e-37d9-4003-be97-7181858b98aa",
        given_name: "Cole",
        family_name: "Coleman",
        email: "admin@simplecitysoftware.com",
      },
    ],
    sortKey: "b351c34f-3217-49a3-83d7-b5134ac73b7c",
    contactsRetrieved: true,
  },
];
